export const UpdateList = [
	{
		date:'2026-05-25',
		comment:'ホームページリニューアル',
	},
	{
		date:'2026-05-28',
		comment:'イラスト2点 追加。\n\n更新履歴(これ) を 追加しました。\nその他、仕様の追加/不具合の修正を行いました。',
	},

	{
		date:'2026-06-01',
		comment:'イラスト1点 追加。\n\n画像表示モーダルにて、\n複数枚の画像を表示できるようにしました。\n\nその他、仕様の追加/不具合の修正を行いました。',
	},

	{
		date:'2026-06-07',
		comment:'Comic Adsを追加しました。\n(主にAdzuki.が制作した、マンガのアフィリエイトリンクとなります。) \n\nスケジュールの内容を更新。',

	},
	{
		date:'2026-06-11',
		comment:'過去に描いたサークルカットを閲覧できるようにしました。\nGalleryページにて確認できます。 \n\nその他細かい不具合の修正を行いました。',

	},
	{
		date:'2026-06-17',
		comment:'つなぐ へのリンクを追加しました。'
	},
	{
		date:'2026-06-23',
		comment:'ブログ機能 を 追加しました。'
	},
	{
		date:'2026-07-02',
		comment:'全面広告機能 を 追加しました。\nその他細かいスタイルの調整を行いました。'
	},
	{
		date:'2026-07-18',
		comment:'9月開催予定のけもケット17 にて、当サークルの当選を確認したため、\nスケジュールの内容を更新致しました。'
	},


];